import { supabase } from './supabase';
import { createR2DownloadUrl } from './r2Download';

export interface PurchaseRow {
  id: string;
  user_id: string;
  product_id: string;
  purchased_at: string;
}

/** Record a purchase for the current user. Call once per product. */
export async function recordPurchase(userId: string, productId: string): Promise<void> {
  const { error } = await supabase.from('purchases').insert({
    user_id: userId,
    product_id: productId,
  });
  if (error) throw new Error(error.message);
}

/** Fetch all purchases for the current user. */
export async function fetchUserPurchases(userId: string): Promise<PurchaseRow[]> {
  const { data, error } = await supabase
    .from('purchases')
    .select('id, user_id, product_id, purchased_at')
    .eq('user_id', userId)
    .order('purchased_at', { ascending: false });
  if (error) throw new Error(error.message);
  return (data ?? []) as PurchaseRow[];
}

export async function createDownloadSignedUrl(
  productId: string,
  fileName: string
): Promise<string> {
  const serverUrl = process.env.REACT_APP_SERVER_URL ?? '';
  if (!serverUrl) {
    throw new Error('REACT_APP_SERVER_URL is not configured');
  }
  const userRes = await supabase.auth.getUser();
  if (userRes.error || !userRes.data.user) {
    throw new Error('You must be logged in to download this file');
  }
  const userId = userRes.data.user.id;
  return createR2DownloadUrl(serverUrl, userId, productId, fileName);
}
